<template>
    <div>
        <div class="container" v-if="loading === false">
            <div class="row pt-10 pb-5">
                <div class="col-sm-9 text-left">
                    <div v-if="membershipType === 'FDX_MEMBER'">
                        <h4 class="heading">
                            Thank you for your interest in joining FDX
                        </h4>
                        <hr />
                        <div class="thankyouMessage">
                            <p>
                                This is our standard membership packet that all our
                                members have agreed to without modification. They
                                are compromise documents that everyone (over 200
                                organizations) agreed they could live with.
                                <a
                                    href="https://registry.financialdataexchange.org/"
                                    target="_blank"
                                    rel="noopener"
                                    >FDX registry</a
                                >
                                comprises a list of some of our current members.<br /><br />
                                These documents are being sent to you subject to
                                FS-ISAC Traffic Light Protocol (TLP) - Amber (which
                                has been adopted by FDX). If you are not familiar
                                with TLP markings, FS-ISAC Amber states:
                            </p>
                            <p class="para1">
                                <strong>FS-ISAC Amber:</strong> Recipients may only
                                share TLP AMBER information with staff in their own
                                organization who need to know, or with service
                                providers to mitigate risks to the member’s
                                organization. If the providers are contractually
                                obligated to protect the confidentiality of the
                                information. TLP AMBER information can be shared
                                with those parties specified above only as widely as
                                necessary to act on the information.
                            </p>
                            <p class="para2">
                                Consenting to the documents attached hereto, you
                                agree to such confidentiality protocols required by
                                TLP Amber. If you do not agree or have some
                                questions, please write to us at
                                fdxmemberservices@financialdataexchange.org.
                            </p>
                            <br />
                            <p>
                                <strong>Attached hereto are the following:</strong>
                            </p>
                            <p>
                                1. The FDX Membership Agreement (with
                                attachments);<br />
                                2. FDX’s
                                <a
                                    href="https://financialdataexchange.org/common/Uploaded%20files/Policies/new/FDX%20Inc.%20Membership%20Agreement%20-%20Execution%20Version-Fillable-Oct24.pdf"
                                    style="color: #019382"
                                    target="_blank"
                                    rel="noopener"
                                    >Membership Agreement</a
                                >
                                (referenced in the Membership Agreement and to which
                                Members are agreeing to be bound);
                                <br />
                                3.
                                <a
                                    href="https://financialdataexchange.org/common/Uploaded%20files/Policies/new/FDX%20-%20Parent%20-%20Subsidiary%20Membership%20Policy%20%5BRatified%5D.pdf"
                                    style="color: #019382"
                                    target="_blank"
                                    rel="noopener"
                                    >FDX’s Parent-Subsidiary Membership Policy</a
                                >
                                which applies to organizations that are owned by one
                                or more other entities; <br />
                            </p>
                            <p>
                                Additional
                                <a
                                    href="https://financialdataexchange.org/FDX/Legal/Policies.aspx"
                                    style="color: #019382"
                                    target="_blank"
                                    rel="noopener"
                                    >Policies</a
                                >
                                and Procedures apply to all FDX Members. Standard
                                Members join for a year and have graduated annual
                                fees based on revenue (See Exhibit A to Membership
                                Agreement).
                            </p>
                            <p>
                                <strong
                                    >By joining as a standard member, you will
                                    receive many benefits available only to FDX
                                    members, including:</strong
                                >
                            </p>
                            <p>
                                • You will have the ability to shape/drive API
                                roadmap and forums to champion for your firm’s
                                needs.<br />
                                • Ability to cross pollinate ideas with other 200+
                                FDX members in semimonthly workgroups ranging from
                                security and data structures to user experience and
                                marketing.<br />
                                • Your company’s vote in any Working Group counts
                                the same as each other firm (including the
                                largest).<br />
                                • Semiannual “developer meetups” Global Summit
                                Spring and Fall.<br />
                                • Access to pre-release versions, supporting
                                artifacts, and tools.<br />
                                • Access to User Experience flow research/focus
                                groups and repositories of other members’ enrollment
                                flows and dashboards.<br />
                                • Access to the contact information of all the other
                                member firms’ data sharing teams.<br />
                                • Access to a community of SME’s in the Data sharing
                                space.<br />
                                • Access to
                                <a
                                    href="https://developer.financialdataexchange.org/"
                                    target="_blank"
                                    rel="noopener"
                                    >FDX Developer Portal</a
                                >.<br />
                                • Access to
                                <a
                                    href="https://registry.financialdataexchange.org/"
                                    target="_blank"
                                    rel="noopener"
                                    >FDX Registry</a
                                >.
                            </p>
                            <p>
                                Please reach out to
                                <span
                                    >fdxmemberservices@financialdataexchange.org</span
                                >
                                if you have any questions.<br /><br />
                                Thank you,<br />
                                FDX Team
                            </p>
                        </div>
                    </div>
                    <div v-else>
                        <h4 class="heading">
                            Thank you for your interest in the FDX API
                            specification
                        </h4>
                        <hr />
                        <div class="thankyouMessage">
                            <p>
                                The receipt of the FDX API specification is
                                contingent on your acceptance, on behalf of
                                {{ orgName }}, of the
                                <a
                                    href="https://financialdataexchange.org/common/Uploaded%20files/Policies/FDX%20Website%20-%20Terms%20of%20Use%20-%20TCs%20(11-13-2019).pdf"
                                    style="color: #019382"
                                    target="_blank"
                                    rel="noopener"
                                    >FDX Terms of Use</a
                                >
                                , FDX API License Agreement and FDX Privacy Policy
                                (collectively, the “T&Cs”).<br /><br />
                                Please reply with your acceptance, on behalf of
                                {{ orgName }}, of T&C’s and FDX will forward you the
                                FDX API specification.
                            </p>
                            <p>
                                We hope your firm joins as a standard member one day
                                and will participate and influence the
                                specifications in our working groups.
                            </p>
                            <p>
                                <strong
                                    >If your firm joins as a standard member, you
                                    will receive many benefits available only to FDX
                                    members, including:</strong
                                >
                            </p>
                            <p>
                                • You will have the ability to shape/drive API
                                roadmap and forums to champion for your firm’s
                                needs.<br />
                                • Ability to cross pollinate ideas with other 200+
                                FDX members in semimonthly workgroups ranging from
                                security and data structures to user experience and
                                marketing.<br />
                                • Your company’s vote in any Working Group counts
                                the same as each other firm (including the
                                largest).<br />
                                • Semiannual “developer meetups” Global Summit (free
                                of charge).<br />
                                • Access to pre-release versions, supporting
                                artifacts, and tools.<br />
                                • Access to User Experience flow research/focus
                                groups and repositories of other members’ enrollment
                                flows and dashboards.<br />
                                • Access to the contact information of all the other
                                member firms’ data sharing teams.<br />
                                • Access to a community of SME’s in the Data sharing
                                space.<br />
                            </p>
                            <p>
                                By your acceptance of the T&Cs on behalf of your
                                company, you represent to FDX that (1) you have
                                reviewed the T&Cs, (2) you have the authority to
                                accept the T&Cs on behalf of your company and (3)
                                your company will be bound by your acceptance
                                thereof.
                            </p>
                            <p>
                                Please reach out to
                                <span
                                    >fdxmemberservices@financialdataexchange.org</span
                                >
                                if you have any questions.<br /><br />
                                Thank you,<br />
                                FDX Team
                            </p>
                        </div>
                    </div>
                    <hr />
                    <label class="checkbox-inline">
                        <input
                            id="condition"
                            type="checkbox"
                            v-model="termsConditions"
                        /><em
                            >I have read and agree to the Financial Data
                            Exchange
                            <a
                                href="https://financialdataexchange.org/common/Uploaded%20files/pdf/FDX%20Website-Terms-of-Use-TC%20(8-12-2024).pdf"
                                style="color: #019382"
                                target="_blank"
                                rel="noopener"
                                >terms and conditions</a
                            >.</em
                        ></label
                    >
                    <hr />
                    <div class="btn-center">
                        <button
                            type="button"
                            class="btn btn-default btn1"
                            @click="initiateDocusignAuthentication('INLINE')"
                            :disabled="!termsConditions"
                        >
                            Continue: Sign Agreements in Docusign
                        </button>
                    </div>
                    <!-- <hr />
                    <button
                        type="button"
                        class="btn btn-default btn1"
                        @click="initiateDocusignAuthentication('EMAIL')"
                        :disabled="!termsConditions"
                    >
                        CONTINUE REGISTRATION VIA EMAIL
                    </button> -->
                </div>
            </div>
        </div>
        <!-- Modal -->
        <div class="modal fade" id="myModal" role="dialog">
            <div class="modal-dialog">
                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">
                            Complete registration with DocuSign
                        </h4>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                        >
                            &times;
                        </button>
                    </div>
                    <div class="modal-body">
                        <p>
                            An email has been sent to
                            {{ JSON.parse(this.$store.state.user).email }}.
                            Please review and sign the documents with DocuSign.
                        </p>
                    </div>
                    <div class="modal-footer">
                        <button
                            type="button"
                            class="btn btn-default btn1"
                            data-dismiss="modal"
                            @click="closeTab()"
                        >
                            CONTINUE
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="loading === true">
            <loader
                object="#1c71d8"
                color1="#ffffff"
                color2="#17fd3d"
                size="5"
                speed="2"
                bg="#343a40"
                objectbg="#999793"
                opacity="80"
                disableScrolling="false"
                name="dots"
            ></loader>
        </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
    name: "ThankyouView",
    mounted() {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
    },
    created() {
        this.$store.state.pageState = "thankyou";
        if (JSON.parse(this.$store.state.user)) {
            if (JSON.parse(this.$store.state.user).organizationRequest) {
                this.orgName = JSON.parse(
                    this.$store.state.user
                ).organizationRequest.name;
            }
            if (JSON.parse(this.$store.state.user).membershipType) {
                this.membershipType = JSON.parse(
                    this.$store.state.user
                ).membershipType;
            }
        }
    },
    data() {
        return {
            termsConditions: false,
            orgName: "your organization",
            membershipType: "FDX_OBSERVER",
            loading: false,
        };
    },
    methods: {
        ...mapActions(["initiateDocusign"]),
        initiateDocusignAuthentication(type) {
            if (this.termsConditions) {
                this.$gtag.event("initiateDocusignAuthentication", {
                    event_category: "general",
                    event_label: "Initiate Docusign Authentication",
                    email: JSON.parse(this.$store.state.user).email,
                    type: type,
                });
                this.initiateDocusign(type);
                this.loading = true;
            }
        },

        respVerifyDocuSignEmail() {
            this.loading = false;
            $("#myModal").modal("show");
        },

        closeTab() {
            window.open("https://financialdataexchange.org/", "_self");
        },
    },
};
</script>

<style scoped>
.container {
    box-sizing: border-box;
    max-width: 1123px;
    font-size: 16px;
    line-height: 24px;
    color: #5a7d95;
}

.heading {
    font-weight: 700;
    font-size: 29px;
    line-height: 34px;
    color: #1978a0;
}

hr {
    border: 2px solid #d8d8d8;
}

.thankyouMessage {
    border: 2px solid #d8d8d8;
    height: 500px;
    overflow-y: auto;
    padding: 15px;
}

.para1 {
    background: #f6f5f5;
    padding: 22px;
}

.para2 {
    font-style: italic;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #5a7d95;
}

p span {
    color: #019382;
}

.btn1 {
    background: #019382;
    border-radius: 6px;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    text-align: center;
    color: #ffffff;
    height: 45px;
}

.btn-center {
  display: flex;
  justify-content: center !important;
  align-items: center !important;
}

.list-group-item {
    text-align: left;
    background: #f6f5f5;
    font-size: 16px;
    line-height: 19px;
    color: #5a7d95;
}

.list-group .active {
    background: #1978a0;
    color: #ffffff;
}

.modal-title {
    font-size: 20px;
    line-height: 22px;
    color: #1978a0;
}

.modal-body {
    font-size: 14px;
    line-height: 20px;
    color: #5a7d95;
    text-align: left;
}
</style>
